import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isLoggedIn, getAuthenticatedCognitoUser } from '../../authentication/cognito';
import ProfileAccount from './blocks/profile-account';
import ProfilePassword from './blocks/profile-password';
import ProfileUser from './blocks/profile-user';
import { PageEvent } from '../../app-page-events';

import './profile.scss';

export default class ProfilePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
    };
  }

  async componentDidMount() {
    if (!isLoggedIn())
      return this.props.onPageUpdateEvent(PageEvent.APP_LOGOUT);

    const cognitoUser = await getAuthenticatedCognitoUser();

    const user = {
      firstName: cognitoUser ? cognitoUser.signInUserSession.idToken.payload.given_name : '',
      lastName: cognitoUser ? cognitoUser.signInUserSession.idToken.payload.family_name : '',
      email: cognitoUser ? cognitoUser.signInUserSession.idToken.payload.email : ''
    }

    this.setState({
      user: user
    });
  }

  handlePageUpdateEvent = async (e) => {
    this.props.onPageUpdateEvent(e);
  }

  render() {
    const { user } = this.state;

    return (
      <React.Fragment>
        <Container style={{
          'marginBottom': '100px'
        }}>
          <Row>
            <Col>
              <ProfileUser
                onNotifyEvent={this.props.onNotifyEvent}
                onPageUpdateEvent={(e) => this.handlePageUpdateEvent(e)}
                user={user}
              />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row>
            <Col>
              <ProfilePassword
                onNotifyEvent={this.props.onNotifyEvent}
                onPageUpdateEvent={(e) => this.handlePageUpdateEvent(e)}
              />
            </Col>
            <Col>
              <ProfileAccount
                onNotifyEvent={this.props.onNotifyEvent}
                onPageUpdateEvent={(e) => this.handlePageUpdateEvent(e)}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
};